module.exports = __webpack_public_path__ + "media/fall-protection-poster.9f099f40.mp4";